import { BannerPrimaryButtonStyled } from './styled/BannerPrimaryButtonStyled';
import { MouseEventHandler } from 'react';

interface IMobileBonusBannerPrimaryButtonProps {
    background?: string;
    children: JSX.Element | JSX.Element[] | string;
    onClick:  MouseEventHandler<HTMLButtonElement>
}

function BannerPrimaryButton(props: IMobileBonusBannerPrimaryButtonProps) {
    const { background, children, onClick } = props;
    return <BannerPrimaryButtonStyled
        background={background}
        onClick={onClick}
        variant={'primary'}
        size={'sm'}
    >
        {children}
    </BannerPrimaryButtonStyled>
}

export default BannerPrimaryButton;
